module.exports = __webpack_public_path__ + "partylineManage/img/logoApp.d32a2ccb.png";